import { DOCUMENT } from "@angular/common";
import { Injectable, inject } from "@angular/core";
import { Meta } from '@angular/platform-browser';
import { LocalRepository } from "@shared/helper/local-repository";
import { UserTypeEnum } from "@shared/model/enum/user-type-enum";

@Injectable({
    providedIn: "root"
})

export class SEOService {
    private metaService = inject(Meta);
    private link = inject(LinkService);
    private _localRepository = inject(LocalRepository);
    private doc = inject(DOCUMENT);


    siteTitle = 'بهخوان | بهتر انتخاب کن، بهتر بخوان';
    siteImage = 'https://behkhaan.ir/assets/icons/icon-144x144.png';
    siteDescription = 'در بهخوان، کتاب‌هایی را که دوست دارید ببینید و به اشتراک بگذارید. به جامعۀ بزرگ کتاب‌دوستان بهخوان بپیوندید.'

    updateTags(config: ITagContent) {
        if (!config) { return; }
        this.seoWriterTest(config);
    }

    setCanonicalUrl(canonicalUrl?: string) {
        const head = this.doc.getElementsByTagName('head')[0];
        let element: HTMLLinkElement | null = this.doc.querySelector(`link[rel='canonical']`) || null;
        if (canonicalUrl) {
            if (element == null) {
                element = this.doc.createElement('link') as HTMLLinkElement;
                head.appendChild(element);
                element.setAttribute('rel', 'canonical')
                element.setAttribute('href', canonicalUrl)
            }
            else {
                this.removeCanonicalUrl();
                const link: HTMLLinkElement = this.doc.createElement('link');
                link.setAttribute('rel', 'canonical');
                this.doc.head.appendChild(link);
                link.setAttribute('href', canonicalUrl);
            }
        }
        else {
            this.removeCanonicalUrl();
        }
    }

    removeCanonicalUrl() {
        const foundedCanonical = this._localRepository.getDocument.querySelector("[rel='canonical']");
        if (foundedCanonical) {
            this.doc.head.removeChild(foundedCanonical);
        }

    }

    seoWriterTest(values: ITagContent) {
        let tags: ISeoTag = new DefaultSiteMetaTag(values);
        tags = new TwitterMetaTag().decorate(tags, values);
        tags = new OgMetaTag().decorate(tags, values);
        tags = new ArticleMetaTag().decorate(tags, values);
        tags = new CanonicalTag().decorate(tags, values);
        // console.log(tags);
        tags.containers.forEach(element => {
            element.metaTags.forEach(meta => {
                if (meta.property == "canonical") {
                    this.link.updateTag(meta)
                }
                else {
                    this.metaService.updateTag(meta)
                }
            })
            element.obsoletedTags.forEach(meta => {
                // console.log('seo removed :', meta);
                if (meta.property == "canonical") {
                    // console.log('canonical');
                    const elm2 = this.htmlLinkElementFinder()
                    if (elm2) {
                        this.link.removeTagElement(elm2 as HTMLLinkElement)
                    }
                }
                else {
                    // console.log('Other');
                    const elm = this.htmlMetaElementFinder(meta);
                    if (elm) {
                        this.metaService.removeTagElement(elm);
                    }
                }
            })

        });


    }


    htmlMetaElementFinder(tag: IMetaTag | ITag) {
        if (tag as IMetaTag) {
            const key = tag.isProperty ? 'property' : 'name';
            const value = tag.property
            const attr_selector = `[${key}="${value}"]`
            return this._localRepository.getDocument.querySelector<HTMLMetaElement>(attr_selector)
        }
        else if (tag as ITag) {
            const key = tag.isProperty ? 'property' : 'name';
            const value = tag.property
            const attr_selector = `[${key}="${value}"]`
            return this._localRepository.getDocument.querySelector<HTMLMetaElement>(attr_selector)
        }
        else return null;
    }

    htmlLinkElementFinder() {
        const foundedCanonical = this._localRepository.getDocument.querySelector("[rel='canonical']");
        return foundedCanonical
    }

}

export class SeoConfig {
    url?: string;
    title?: string;
    image?: string;
    robots?: string;
    page?: PageKind;
    article?: OgArticle;
    profile?: OgProfile;
    description?: string;
    canonical?: string;
}

export class OgArticle {
    tags?: string[];
    publishedTime?: string;
    author?: OgProfile;
}

export class OgProfile {
    fullName?: string;
    userName?: string;
    userType?: UserTypeEnum;
}

export enum PageKind {
    home = 0,               // * 0
    book,                   // * 1
    post,                   // * 2
    genre,                  // * 3
    review,                 // * 4
    userProfile,            // * 5
    authorProfile,          // * 6
    authorBooks,            // * 7
    publisherProfile,       // * 8
    booklist,               // * 9
    quote,                  // * 10
    notFound,               // * 11
    all
}


interface ITag {
    property: string;
    content: string,
    kind: PageKind,
    isProperty: boolean,
    isCanonical?: boolean,
}

export interface ITagContent {
    [key: string]: string | undefined;
    url?: string;
    title?: string;
    image?: string;
    robots?: string;
    description?: string;
    canonical?: string;
    published_time?: string
    author?: string
}

export class RemoveTagContent implements ITagContent {
    [key: string]: string | undefined;
    url?: string = undefined;
    title?: string = undefined;
    image?: string = undefined;
    robots?: string = undefined;
    description?: string = undefined;
    canonical?: string = undefined;
    published_time?: string = undefined;
    author?: string = undefined;
}

interface IMetaTag {
    [key: string]: string;
    charset: string;
    content: string;
    httpEquiv: string;
    id: string;
    itemprop: string;
    name: string;
    property: string;
    scheme: string;
    url: string;
    isCanonical: string;
}

interface ITagContainer {
    name: string;
    metaTags: IMetaTag[],
    obsoletedTags: ITag[],
}
interface ISeoTag {
    containers: ITagContainer[]
    toMetaTag(tag: ITag, contents?: ITagContent): IMetaTag
}

class MetaTagMappter {
    public static Get(): MetaTagMappter {
        return new MetaTagMappter();
    }
    toMetaTag(tag: ITag, contents: ITagContent): IMetaTag | undefined {
        const key = tag.isProperty ? 'property' : 'name';
        const x: IMetaTag = {} as IMetaTag;


        x[key] = tag.property;
        if (contents) {
            const keys = Object.keys(contents);
            const found = keys.find(k => x[key]?.endsWith(k))
            x.content = found ? contents[found]! : '';
            if (!found)
                return undefined;
        }
        else return undefined;
        Object.keys(x).forEach(element => {
            if (!x[element])
                delete x[element]
        });
        return x;
    }
}

class DefaultSiteMetaTag implements ISeoTag {

    /**
     *
     */
    constructor(contents?: ITagContent) {
        this.containers = [];
        const tags: ITag[] = [{
            property: 'description',
            content: '',
            kind: PageKind.home,
            isProperty: false
        },
        {
            property: 'robots',
            content: '',
            kind: PageKind.home,
            isProperty: false
        }];
        const metaTags = tags.map(x => this.toMetaTag(x, contents)).filter(x => x?.content != undefined);
        const obsoletedTags = tags.filter(x => metaTags.find(c => c.name == x.property || c.property == x.property || c.content === undefined) == undefined)
        this.containers.push({
            name: 'site',
            metaTags,
            obsoletedTags

        })

    }
    toMetaTag(tag: ITag, contents?: ITagContent): IMetaTag {
        return MetaTagMappter.Get().toMetaTag(tag, contents!)!;
    }
    containers: ITagContainer[];

}


interface IMetaTagDecorator extends ISeoTag {
    decorate(seo: ISeoTag, contents?: ITagContent): ISeoTag
}
abstract class MetaTagDecoratorBase implements IMetaTagDecorator {

    toMetaTag(tag: ITag, contents?: ITagContent): IMetaTag {
        return MetaTagMappter.Get().toMetaTag(tag, contents!)!;
    }
    abstract decorate(seo: ISeoTag, contents?: ITagContent): ISeoTag;
    containers: ITagContainer[] = [];

}
class TwitterMetaTag extends MetaTagDecoratorBase {
    constructor() {
        super();

    }
    decorate(seo: ISeoTag, contents?: ITagContent): ISeoTag {
        this.containers = [...seo.containers];
        const tags = [
            {
                property: 'twitter:title',
                content: '',
                kind: PageKind.all,
                isProperty: false
            },
            {
                property: 'twitter:description',
                content: '',
                kind: PageKind.all,
                isProperty: false
            },
            {
                property: 'twitter:image',
                content: '',
                kind: PageKind.all,
                isProperty: false
            }
        ];
        const metaTags = tags.map(x => this.toMetaTag(x, contents)).filter(x => x?.content != undefined);
        const obsoletedTags = tags.filter(x => metaTags.find(c => c.name == x.property || c.property == x.property || c.content === undefined) == undefined)

        this.containers.push({
            name: 'twitter',
            metaTags,
            obsoletedTags
        });
        return this;
    }
    // containers: ITagContainer[];

}

class ArticleMetaTag extends MetaTagDecoratorBase {
    constructor() {
        super();

    }
    decorate(seo: ISeoTag, contents?: ITagContent): ISeoTag {
        this.containers = [...seo.containers];
        const tags = [
            {
                property: 'article:author',
                content: '',
                kind: PageKind.all,
                isProperty: true
            },
            {
                property: 'article:published_time',
                content: '',
                kind: PageKind.all,
                isProperty: true
            }
        ];
        const metaTags = tags.map(x => this.toMetaTag(x, contents)).filter(x => x?.content != undefined);
        const obsoletedTags = tags.filter(x => metaTags.find(c => c.name == x.property || c.property == x.property || c.content === undefined) == undefined)

        this.containers.push({
            name: 'article',
            metaTags,
            obsoletedTags
        });
        return this;
    }
    // containers: ITagContainer[];

}

class OgMetaTag extends MetaTagDecoratorBase {
    /**
     *
     */
    constructor() {
        super();

    }

    decorate(seo: ISeoTag, contents?: ITagContent): ISeoTag {
        this.containers = [...seo.containers];
        const tags = [
            {
                property: 'og:title',
                content: '',
                kind: PageKind.home,
                isProperty: true
            },
            {
                property: 'og:description',
                content: '',
                kind: PageKind.home,
                isProperty: true
            },
            {
                property: 'og:site_name',
                content: '',
                kind: PageKind.home,
                isProperty: true
            },
            {
                property: 'og:type',
                content: '',
                kind: PageKind.home,
                isProperty: true
            },
            {
                property: 'og:image',
                content: '',
                kind: PageKind.home,
                isProperty: true
            },
            {
                property: 'og:url',
                content: '',
                kind: PageKind.home,
                isProperty: true
            }
        ];
        const metaTags = tags.map(x => this.toMetaTag(x, contents)).filter(x => x?.content != undefined);
        const obsoletedTags = tags.filter(x => metaTags.find(c => c.name == x.property || c.property == x.property || c.content === undefined) == undefined)

        this.containers.push({
            name: 'og',
            metaTags,
            obsoletedTags
        });
        return this;
    }
    // containers: ITagContainer[];

}

class CanonicalTag extends MetaTagDecoratorBase {
    /**
     *
     */
    constructor() {
        super();

    }

    decorate(seo: ISeoTag, contents?: ITagContent): ISeoTag {
        this.containers = [...seo.containers];
        const tags: ITag[] = [
            {
                property: 'canonical',
                content: '',
                kind: PageKind.home,
                isProperty: true,
                isCanonical: true
            }
        ];

        const metaTags = tags.map(x => this.toMetaTag(x, contents)).filter(x => x?.content != undefined);
        const obsoletedTags = tags.filter(x => metaTags.find(c => c.name == x.property || c.property == x.property || c.content === undefined) == undefined)

        this.containers.push({
            name: 'canonical',
            metaTags,
            obsoletedTags
        });
        return this;
    }
    // containers: ITagContainer[];

}



@Injectable({
    providedIn: 'root'
})
export class LinkService {
    private _localRepository = inject(LocalRepository);


    updateTag(data: ITag | IMetaTag) {
        let elementCanonical = this._localRepository.getDocument.querySelector<HTMLLinkElement>("[rel='canonical']");
        if (elementCanonical) {
            const href = elementCanonical.getAttribute("href")
            if (href == data.content)
                return;
        }
        else {
            elementCanonical = this._localRepository.getDocument.createElement('link') as HTMLLinkElement;
            elementCanonical.setAttribute('rel', 'canonical')
            this._localRepository.getDocument.head.appendChild(elementCanonical);
        }

        elementCanonical.setAttribute("href", data.content!)

    }

    removeTagElement(element: HTMLLinkElement) {
        try {
            if (element) {
                this._localRepository.getDocument.removeChild(element)
            }
        }
        catch {
            console.log('did not remove');
        }
    }
}